<template>
  <header class="dtop">
    <div>
      <h1>{{ title }}</h1>
      <span v-if="subtitle" class="sub">{{ subtitle }}</span>
    </div>
    <div v-if="$slots.actions" class="row" style="gap:var(--space-3)">
      <slot name="actions" />
    </div>
  </header>
</template>

<script>
// Cabeçalho sticky de página do módulo Clínica (.dtop do shell).
export default {
  name: "ClinicPageHeader",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" }
  }
};
</script>
